@if (live && scoreboard.started) {
    <ms-live-timer [scoreboard]="scoreboard" [timeValue]="timeValue" [eventId]="eventId" [scoreboardType]="scoreboardType" />
} @else {
    <ms-prematch-timer
        [calendarInfoDisplay]="calendarInfoDisplay"
        [start]="start"
        [intervalForRedPrematchTimer]="intervalForRedPrematchTimer"
        [isDynamicTimer]="isDynamicTimer" />
}
